import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const signupContainer = css`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const signupSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: ${3 * unit}px;
  width: 100%;
`

export const loaderWrapper = css`
  height: 50vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  ${MQ.PHONES} {
    height: 50vh;
    width: 100vw;
  }
`
